import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ResizerIcon = ({
  color = 'black90',
  marginLeft,
  marginRight,
  width = 14,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <g fill={getSemanticTextColor(color)}>
        <path
          d="M11.481 6.936c.391-.39 1.024-.39 1.415 0 .36.36.388.927.083 1.32l-.083.094-4.546 4.546c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.095 4.545-4.545zM10.657-.707c.39-.39 1.024-.39 1.414 0 .36.36.389.928.084 1.32l-.084.094L.707 12.071c-.39.39-1.024.39-1.414 0-.36-.36-.388-.927-.083-1.32l.083-.094L10.657-.707z"
          transform="translate(1 1)"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
